import Component from '../inherited/Component'
import axios from 'axios'

export default class QuickView extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._quickViewPopup = document.querySelector('[data-quick-view-popup]')
    this._quickViewPopupContent = this._quickViewPopup.querySelector('[data-quick-view-popup-content]')
    this._quickViewCloses = this._quickViewPopup.querySelectorAll('[data-quick-view-popup-close]')
    this._loading = false
  }

  mount () {

    for (let closeElem of this._quickViewCloses) {
      closeElem.addEventListener('click', e => {
        this._closePopup()
      })
    }

    this._quickViewPopup.addEventListener('click', e => {
      for (let closeElem of this._quickViewCloses) {
        if (closeElem === e.target) {
          this._closePopup()
          return
        }
      }
    })

    document.addEventListener('product:added', e => this._closePopup())

    document.addEventListener('click', async e => {
      let elem = e.target
      if (elem.hasAttribute('data-quick-view-trigger')) {
        e.preventDefault()
        e.stopPropagation()
        elem.setAttribute('disabled', 'disabled')
        elem.classList.add('loading')
        await this.quickViewProduct(elem.dataset.quickViewTrigger)
        elem.removeAttribute('disabled')
        elem.classList.remove('loading')
      }
    })
    
  }

  _openPopup () {
    this._quickViewPopup.classList.add('shown')
  }

  _closePopup () {
    this._quickViewPopup.classList.remove('shown')
  }

  async quickViewProduct (handle) {
    if (this._loading) return false
    this._loading = true
    this._quickViewPopupContent.innerHTML = ''
    let url = `/products/${handle}?view=quick-view`
    let { data } = await axios.get(url)
    let parser = new DOMParser()
    let html = parser.parseFromString(data, 'text/html')
    let fetchedElem = html.querySelector('[data-quick-view-result]')
    this._quickViewPopupContent.innerHTML = fetchedElem.innerHTML

    this._theme.mountComponents(this._quickViewPopupContent)

    let section = this._quickViewPopupContent.querySelector(`[data-section-id="product-template"]`)
    if (section) {
      document.dispatchEvent(new CustomEvent('quick-view-complete', { detail: section }))
    }

    this._openPopup()
    this._loading = false
  }
}